import { render, staticRenderFns } from "./PetProfile.vue?vue&type=template&id=6b61f650&scoped=true&"
import script from "./PetProfile.vue?vue&type=script&lang=js&"
export * from "./PetProfile.vue?vue&type=script&lang=js&"
import style0 from "./PetProfile.vue?vue&type=style&index=0&id=6b61f650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61f650",
  null
  
)

export default component.exports